var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 59,
    viewBox: "0 0 47 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0001 58.9571H1.0033V47.3575L22.7574 46.1133H47.0001V58.9571Z",
    fill: "url(#paint0_linear_567_65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00342 58.9609H7.00164L22.7576 45.7961L33.2734 37.2871C42.5851 29.7815 46.3179 25.4467 46.3179 17.7003V17.62C46.3179 6.9838 37.1667 0 23.1589 0C9.43215 0 0 7.94708 0 19.7072V20.1085H15.4928L15.5329 19.5868C15.854 15.4125 18.5432 12.5628 23.1589 12.5628C27.1726 12.5628 29.9421 15.0914 29.9421 18.6636V18.7439C29.9421 21.9548 28.6577 24.4834 21.5535 30.3434L1.00342 47.3614V58.9609Z",
    fill: "url(#paint1_angular_567_65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0653 12.1514H40.9016V7.13434H40.9485L44.3869 12.1514H46.7215V2.49854H43.8851V7.43536H43.8383L40.4267 2.49854H38.0653V12.1514Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_65",
    x1: 0.722338,
    y1: 52.9633,
    x2: 46.9599,
    y2: 52.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#639462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF1EA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_567_65",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8413 20.4296) rotate(179.091) scale(35.9671 35.9673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#629361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.b4115e744d1245bbef27a8cc4af517e0.svg";
export { ForwardRef as ReactComponent };